<template>
  <AttributesTable
    :attributes="editableVehicle.attributes"
    :editableAttributeOrigin="editableAttributeOrigin"
    @addNewAttribute="addNewAttribute"
    @saveAttribute="saveAttribute"
    @deleteAttribute="deleteAttribute">
  </AttributesTable>
</template>

<script>
import AttributesTable from "../../Shared/AttributesTable";
import { AttributeOrigin } from "../../../models/AttributeOrigin";
import _ from "lodash";

export default {
    components: { AttributesTable },
    props: {
        vehicle: {
            type: Object,
            default: function() {
                return null;
            }
        },
        isOpen: Boolean
    },
    data() {
        return {
            editableVehicle: _.cloneDeep(this.vehicle),
            editableAttributeOrigin: AttributeOrigin.RG
        };
    },
    watch: {
        vehicle(val) {
            this.editableVehicle = (!val) ? {} : _.cloneDeep(val);
        }
    },
    methods: {
        addNewAttribute: function(newAttribute, eventTargetId) {
            this.$emit("addNewAttribute", newAttribute, eventTargetId);
        },
        saveAttribute: function(attribute, eventTargetId) {
            this.$emit("saveAttribute", attribute, eventTargetId);
        },
        deleteAttribute: function(attribute, eventTargetId) {
            this.$emit("deleteAttribute", attribute, eventTargetId);
        }
    }
};
</script>
